exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:800px){.container-fluid[data-v-f99185e6]{width:75%}}.back-to-top[data-v-f99185e6]{cursor:pointer;position:fixed;bottom:20px;right:20px;display:none}.centered-and-cropped[data-v-f99185e6]{object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f99185e6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/windows/WindowList.vue
// module id = 125
// module chunks = 0